export default "__VITE_ASSET__DVebIHqA__"